export const checkUrlImages = (url: string | undefined): string => {
    if (url) {
        return url.endsWith('/') ? url : `${url}/`;
    }
    return '';
};
